import Type6 from "./option";

export default Type6;
